import { CirclePlay } from "lucide-react";

import { Button } from "../../components/ui/button";

import heroImg from "../../components/image/assets/hero.svg";

export default function HeroSection() {
  return (
    <section className="section-padding">
      {/* <div className="container-safe flex items-center justify-center gap-4"> */}
      <div className="container-safe xs:gap-22 grid items-center justify-center gap-7 md:grid-cols-2 md:gap-4">
        <div className="w-full md:max-w-[480px] xl:ml-auto">

          <h1 className="xs:text-5xl xs:leading-12 text-4xl leading-10 font-bold tracking-tight">
            Win More Jobs Faster
          </h1>
{/**All-in-One Tools to Power Your Home Improvement Business | All Tools For Home Improvement Pros*/}
          <p className="xs:mt-6 mt-3 text-2xl leading-[30px] font-semibold tracking-tighter sm:text-3xl sm:leading-9">
            Simple. Free. Built Exclusively for Pros - Like You
          </p>

          <div className="xs:mt-10 max-xs:flex-wrap mt-7 flex items-center gap-3 md:mt-16 md:justify-between">
            <Button>
              <a href="../create_company">
                Start Free
              </a>
            </Button>
            <Button asChild variant="link" className="px-0" disabled>
              <a
                href="https://www.youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <CirclePlay className="size-6" />
                Watch Demo
              </a>
            </Button>
          </div>
        </div>

        <img
          src={heroImg}
          alt="MrJoe preview"
          className="-z-1 h-auto w-full md:h-[500px] md:w-auto"
        />
      </div>
    </section>
  );
}
